import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewSponsorshipApplicationsRoutingModule } from './view-sponsorship-applications-routing.module';
import { ViewSponsorshipApplicationsComponent } from './view-sponsorship-applications.component';
import { HeaderModule } from 'src/app/shared/components/header/header.module';
import { EditSponsorshipApplicationComponent } from './edit-sponsorship-application/edit-sponsorship-application.component';
import { FooterModule } from 'src/app/shared/components/footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';

@NgModule({
  declarations: [
    ViewSponsorshipApplicationsComponent,
    EditSponsorshipApplicationComponent
  ],
  imports: [
    CommonModule,
    ViewSponsorshipApplicationsRoutingModule, 
    HeaderModule, 
    FooterModule, 
    FormsModule, 
    ReactiveFormsModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule
  ], 
  exports: [
    // ViewSponsorshipApplicationsComponent
  ]
})
export class ViewSponsorshipApplicationsModule { }
